import { useEffect, useState } from 'react';
import axios from 'axios';
import { getAppCheckHeaders } from '../firebase';

const API_BASE = process.env.REACT_APP_SHOPKEEP_BACKEND;

const usePublicHelpDocs = () => {
  const [helpCategories, setHelpCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHelpDocs = async () => {
      try {
        const headers = await getAppCheckHeaders();
        const response = await axios.get(`${API_BASE}/api/helpdocs`, { headers });
        if (response.data?.success && response.data?.data?.helpCategories) {
          setHelpCategories(response.data.data.helpCategories);
        } else {
          setError('Failed to load help content.');
        }
      } catch (err) {
        const status = err.response?.status;
        const message = err.response?.data?.message || err.message;
        const url = `${API_BASE}/api/helpdocs`;
        console.error(`Error fetching public help docs from ${url}: ${status || 'network error'} - ${message}`, err);
        setError('Unable to load help content. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchHelpDocs();
  }, []);

  return { helpCategories, loading, error };
};

export default usePublicHelpDocs;
